import * as React from 'react';
import {useEffect, useState} from 'react';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import {createTheme, ThemeProvider} from '@mui/material/styles';
import Copyright from "../Copyrigtht";
import "./login.css";
import AuthService from "../../services/AuthService";
import {useLocation, useNavigate} from "react-router-dom";
import {APP_DATA, CALLBACK_URL} from "../../config/settings";
import {Alert} from "@mui/material";
import fullLogo from "./full-logo.png";

const theme = createTheme();

export default function Login() {
    const location = useLocation()
    const navigate = useNavigate();

    const [errors, setErrors] = useState([]);


    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const idToken = params.get("idToken");
        if (idToken) {
            localStorage.setItem('jwt', idToken);
            const refreshToken = params.get("refreshToken");
            // const callbak = params.get("callbak");
            if (refreshToken) {
                localStorage.setItem('refreshToken', refreshToken);
            }
            localStorage.setItem('callback', CALLBACK_URL);
            // if (callbak) {
            //     localStorage.setItem('callbak', callbak);
            // }
            navigate(APP_DATA.WELCOME_ROUTER);
        }
    }, []);


    const handleSubmit = async (event) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        const email = data.get('email');
        const password = data.get('password');
        if (email && password) {
            const res = await AuthService.login(email, password);
            if (res.success) {
                localStorage.setItem('jwt', res.data.idToken.jwtToken);
                localStorage.setItem('refreshToken', res.data.refreshToken.token);
                localStorage.setItem('user', JSON.stringify(res.data.idToken.payload));
                navigate(APP_DATA.WELCOME_ROUTER);
            } else {
                setErrors(res.msg)
            }
        }
    };
    const loadErrors = () => {
        return errors.map((error, i) => {
            return <Alert severity="error" key={i}>{error}</Alert>
        })
    }
    return (
        <ThemeProvider theme={theme}>
            <Container component="main" maxWidth="xs">
                <CssBaseline/>
                <Box
                    sx={{
                        marginTop: 8,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}
                >
            <img src={fullLogo} width={"200px"} alt={"logo"}/>
            {/*<Typography variant={"h4"} className="title">Drive Login</Typography>*/}

                    <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            id="email"
                            label="Email Address"
                            name="email"
                            autoComplete="email"
                            autoFocus
                        />
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            name="password"
                            label="Password"
                            type="password"
                            id="password"
                            autoComplete="current-password"
                        />
                        {/*<FormControlLabel*/}
                        {/*    control={<Checkbox value="remember" color="primary" />}*/}
                        {/*    label="Remember me"*/}
                        {/*/>*/}
                        {loadErrors()}
                        <Button
                            className="submitButton"
                            type="submit"
                            fullWidth
                            variant="contained"
                            sx={{mt: 3, mb: 2}}
                        >
                            Log In
                        </Button>
                        {/*<Grid container>*/}
                        {/*    <Grid item xs>*/}
                        {/*        <Link href="#" variant="body2">*/}
                        {/*            Forgot password?*/}
                        {/*        </Link>*/}
                        {/*    </Grid>*/}
                        {/*    <Grid item>*/}
                        {/*        <Link href="#" variant="body2">*/}
                        {/*            {"Don't have an account? Sign Up"}*/}
                        {/*        </Link>*/}
                        {/*    </Grid>*/}
                        {/*</Grid>*/}
                    </Box>
                </Box>
                <Copyright sx={{mt: 8, mb: 4}}/>
            </Container>
        </ThemeProvider>
    );
}